import { SET_CHECKOUT_DATA } from '@/vuex/mutations-types';
const CHECKOUT_DATA = 'CHECKOUT_DATA';

let state = {};

state = {
  checkoutData: uni.getStorageSync(CHECKOUT_DATA) || [],
};







const mutations = {
  [SET_CHECKOUT_DATA](state, value) {
    state.checkoutData = value;
    uni.setStorageSync(CHECKOUT_DATA, value);
  },
};
export default {
  state,
  mutations,
};
